import { axiosClient } from './axios_client';

function getMe() {
  return axiosClient.get('/api/users/me');
}

function updateMe(data) {
  return axiosClient.put('/api/users/me', data);
}

function getAllUsers(params = {}) {
  return axiosClient.get('/api/users', { params });
}

function getUserById(id) {
  return axiosClient.get(`/api/users/${id}`);
}

function getStatistics() {
  return axiosClient.get('/api/users/statistics');
}

function updateUser(id, data) {
  return axiosClient.put(`/api/users/${id}`, data);
}

function updateUserRole(id, role) {
  return axiosClient.put(`/api/users/${id}/role`, { role });
}

function updateUserStatus(id, status) {
  return axiosClient.put(`/api/users/${id}/status`, { status });
}

function deleteUser(id) {
  return axiosClient.delete(`/api/users/${id}`);
}

function addFcmToken(data) {
  return axiosClient.post('/api/users/me/fcm-token', data);
}

export const user_api = {
  getMe,
  updateMe,
  getAllUsers,
  getUserById,
  getStatistics,
  updateUser,
  updateUserRole,
  updateUserStatus,
  deleteUser,
  addFcmToken,
};
